// extracted by mini-css-extract-plugin
export default {"link":"vN-z","disabled":"wN-z"};